import { render, staticRenderFns } from "./CoreChart-num3.vue?vue&type=template&id=46474dc0&scoped=true&"
import script from "./CoreChart-num3.vue?vue&type=script&lang=js&"
export * from "./CoreChart-num3.vue?vue&type=script&lang=js&"
import style0 from "./CoreChart-num3.vue?vue&type=style&index=0&id=46474dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46474dc0",
  null
  
)

export default component.exports